module.exports = __webpack_public_path__ + "static/preview-piclife-476e14ab523981d01cf4289974df2cec.png";